import { BaseService } from '../base';

export interface ZipcodeError {
  error: boolean;
  message: string;
}

export interface ZipcodeSuccess {
  cep: string;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  blocked?: boolean;
  location?: {
    type: string;
    coordinates: number[];
  };
}

export type ZipcodeData = ZipcodeSuccess | ZipcodeError;

export type ZipcodePurpose = 'quotation' | 'billing';

export class ZipcodeService extends BaseService {
  constructor() {
    super();
  }

  async getAddressByZipcode(
    cep: string,
    purpose?: ZipcodePurpose,
    policyId?: string,
    productCode?: string,
  ): Promise<{
    success: boolean;
    data?: ZipcodeData;
    error?: string;
  }> {
    try {
      const cleanCep = cep.replace(/\D/g, '');

      if (cleanCep.length !== 8) {
        return {
          success: false,
          error: 'CEP inválido',
        };
      }

      const params = new URLSearchParams();
      if (purpose) params.set('purpose', purpose);
      if (policyId) params.set('policyId', policyId);
      if (productCode) params.set('productCode', productCode);
      const qs = params.toString();
      const response = await this.get(
        `/portal/v1/services/zipcode/${cleanCep}${qs ? `?${qs}` : ''}`,
        {},
        import.meta.env.VITE_API_URL
      );
      return await this.handleJsonResponse<ZipcodeData>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro ao buscar CEP',
      };
    }
  }
}

export const zipcodeService = new ZipcodeService();
